"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetFeedbackMode = void 0;
exports.WidgetFeedbackMode = {
    None: "none",
    During: "during",
    End: "end",
};
